import { Component, Input, OnChanges } from '@angular/core';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { cloneDeep, remove, sortBy } from 'lodash';
import { FieldTypeNumberComponent } from "../../../shared/components/field-type-number/field-type-number.component";
import { FieldTypeSwitchComponent } from "../../../shared/components/field-type-switch/field-type-switch.component";
import { CustomizeFieldsSwitchFormComponent } from "../customize-fields-switch-form/customize-fields-switch-form.component";
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AfTranslateDirective } from '@shared/modules/translate/directive/af-translate.directive';
import { NgClass } from '@angular/common';
import { MenuModule } from 'primeng/menu';
import { ColorsPipe } from '@shared/filters/colors/colors.pipe';
import { FormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { CustomizeCodificationValuesComponent } from '../customize-codification-values/customize-codification-values.component';

@Component({
    selector: 'customize-field-formula',
    templateUrl: './customize-field-formula.component.html',
    standalone: true,
    imports: [FieldTypeNumberComponent, FieldTypeSwitchComponent, CustomizeFieldsSwitchFormComponent, AfTranslatePipe, NgClass, AfTranslateDirective, MenuModule, ColorsPipe, FormsModule, InputNumberModule, DragDropModule, CustomizeCodificationValuesComponent],
})
export class CustomizeFieldFormulaComponent implements OnChanges {
  customizeFieldFormula: any ={
    showConfigurationEncoding: false,
    configurationFieldForm: {
      label: this.translate.instant('customize-field-formula.configuration-group'),
      description: this.translate.instant('customize-field-formula.user-help-config')
    },
    decimalsInfo: {
      label: this.translate.instant('customize-field-list.decimals'),
      positive: true
    },
    formulaItems: []
  }

  constructor(private translate: AfTranslateFactory,
    private modalService: ModalServiceService,
    private commonUtilsService: CommonUtilsService) {}

  @Input() field: any = null;
  @Input() isPrivate: any = null;
  @Input() hiddenInLandings: boolean = false;
  @Input() concept: any = {};
  @Input() previewMode: boolean = false;

  ngOnChanges(): void {
    this.configureInitField();
    this.customizeFieldFormula.decimalsInfo.noEditable = this.field.noEditable || this.previewMode;
  }

  configureInitField(){
    this.customizeFieldFormula.field = this.field;
    this.customizeFieldFormula.field.fieldEncodings = this.customizeFieldFormula.field.fieldEncodings?this.customizeFieldFormula.field.fieldEncodings:[];
    this.customizeFieldFormula.field.codeColor = Boolean(this.customizeFieldFormula.field.fieldEncodings?.length);
    if (this.customizeFieldFormula.field.fieldEncodings?.length) {
      this.customizeFieldFormula.field.fieldEncodings.forEach((encoding:any) => {
        this.commonUtilsService.setEncodingDisplayText(encoding);
      });
      this.customizeFieldFormula.field.fieldEncodings = sortBy(this.customizeFieldFormula.field.fieldEncodings, 'numOrder');
    }
    if(this.customizeFieldFormula.field.fieldId && this.customizeFieldFormula.field.formula){
      this.extractFormula();
    }
  }

  extractFormula(){
    this.customizeFieldFormula.formulaItems = [];
    let formulaItems: any = this.customizeFieldFormula.field.formula.split('#');
    this.customizeFieldFormula.formulaFieldsDeleted = false;
    formulaItems.forEach((item:any) => {
      if(this.isOperator(item)){
        this.customizeFieldFormula.formulaItems.push({text:item==='*'?'x':item, id:item, type: 'operator'});
      }else if(item.indexOf('[')!==-1){
        let fieldId : any = item.slice(1,-1);
        let field: any = this.searchItem(this.concept.fieldContainers, fieldId);
        let itemField: any = {
          text: field? field?.label : 'field#'+fieldId,
          fieldId: field? field?.fieldId : fieldId,
          type: 'number'
        }
        if(!field && !this.previewMode){
          this.customizeFieldFormula.formulaFieldsDeleted = true;
          this.customizeFieldFormula.configurationFieldForm.error = true;
          itemField.deleted = true;
        }
        this.customizeFieldFormula.formulaItems.push(itemField);
      }else{
        let itemNumber: any = {
          text: item,
          type: 'number',
          isNumber: true
        }
        this.customizeFieldFormula.formulaItems.push(itemNumber);
      }
    });
  }

  isOperator(item: any){
    let operators: any = ['+', '-', '*', '/', '(', ')'];
    return operators.filter((operator:any)=>{ return operator === item})[0];
  }

  searchItem(containers:any, itemId:any){
    itemId = parseInt(itemId);
    for(let container of containers){
      for(let field of container.fields){
        if(field.fieldId === itemId){
            return field;
        }
      }
      if(container.subContainers){
        for(let subContainer of container.subContainers){
          for(let subField of subContainer.fields){
            if(subField.fieldId === itemId){
              return subField;
            }
          }
        }
      }
    }
  }

  itemSelected(e:any, type:any){
    this.customizeFieldFormula.field[type] = e.newValue;
  }

  editEncodingItem(encodingItem:any) {
    encodingItem.showConfigurationEncoding = true;
    this.customizeFieldFormula.showItemConfigurationEncoding = true;
  }

  openNewEncoding(){
    this.customizeFieldFormula.showConfigurationEncoding = true;
  }

  closeEncodingValue(e: any, type: any){
    this.customizeFieldFormula.encondingSaveError = false;
    if(e.error){
      this.customizeFieldFormula.encondingError = true;
    }else{
      this.customizeFieldFormula.encondingError = false;
      if(type === 'edit'){
        this.customizeFieldFormula.showItemConfigurationEncoding = false;
      }else{
        this.customizeFieldFormula.showConfigurationEncoding = false;
      }
    }
  }

  deleteEncodingItem(encodingItem:any) {
    remove(this.customizeFieldFormula.field.fieldEncodings, encodingItem);
  }
  reorderContainer(event: any){
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
  }

  validateSave(){
    let errors = false;
    if(this.customizeFieldFormula.formulaItems.length && !this.customizeFieldFormula.formulaFieldsDeleted){
      this.customizeFieldFormula.configurationFieldForm.error = false;
    }else{
      this.customizeFieldFormula.configurationFieldForm.error = true;
      errors = true;
    }
    if(this.customizeFieldFormula.field.codeColor){
      if(this.customizeFieldFormula.encondingError){
        errors = true;
      }else if(!this.customizeFieldFormula.field.fieldEncodings?.length){
        this.customizeFieldFormula.encondingSaveError = true;
        errors = true;
      }else{
        this.customizeFieldFormula.encondingSaveError = false;
      }
    }
    if(!errors && !this.customizeFieldFormula.field.codeColor){
      this.customizeFieldFormula.field.fieldEncodings = [];
    }
    return !Boolean(errors);
  }

  modifyFieldAtributes(type:any, value:any) {
      if(!this.customizeFieldFormula.field.fieldAttributes){
          this.customizeFieldFormula.field.fieldAttributes = {};
      }
      this.customizeFieldFormula.field.fieldAttributes[type] = value;
  }

  launchFormulaSettings(){
    let that:any = this.customizeFieldFormula;
      if(!that.field.noEditable){
        let configurationField: any = {
          concept: this.concept,
          fieldTypeId: that.field.fieldTypeId,
          fieldContainerId: that.field.fieldContainerId,
          fieldId: that.field.fieldId,
          formula: that.field.formula,
          formulaItems: that.formulaItems,
          formulaFieldsDeleted: that.formulaFieldsDeleted
        }
        this.modalService.modalFormulaSettings(configurationField).subscribe((result:any)=>{
          if(result.result === 'ok'){
            that.field.formula = result.formula;
            that.formulaItems = result.items;
            that.configurationFieldForm.error = false;
            that.formulaFieldsDeleted = false;
          }
          // else{
          //   // that.formulaItems = that.formulaItemsCopy;
          // }
        })
      }
  }

  resetResultConfigurated(){
    this.customizeFieldFormula.formulaItems = [];
    this.customizeFieldFormula.field.formula = '';
  }

  changeOptionOn(e:any, type:string){
    switch(type){
      case 'codeColor':
        this.customizeFieldFormula.field.codeColor = e.newValue;
        if(!e.newValue){
          this.customizeFieldFormula.encondingError = false;
          this.customizeFieldFormula.showItemConfigurationEncoding = false;
          this.customizeFieldFormula.field.fieldEncodings.forEach((encondingItem: any) => {
            encondingItem.showConfigurationEncoding = false;
          });
        }
        if(!this.customizeFieldFormula.field.fieldEncodings?.length){
          this.openNewEncoding();
        }
        break;
      case 'hidden':
        this.customizeFieldFormula.field.hidden = e.newValue;
        break;
      case 'nullsAsZero':
        this.customizeFieldFormula.field.nullsAsZero = e.newValue;
        this.modifyFieldAtributes('nullsAsZero', e.newValue)
        break;
      default:
        this.customizeFieldFormula.field[type] = e.newValue;
        break;
    }
  }
}
